// extracted by mini-css-extract-plugin
module.exports = {"small":"button_small__1MCUM","large":"button_large__3rqL8","icon":"button_icon__2fIfD"};